export default __webpack_public_path__ + "static/media/feature-batch.b39dd80c.webp";